export default __webpack_public_path__ + "static/media/c2.96e92c53.png";